import * as Api from '@ViewModels';
import { provider, providerTag, toggle } from './helpers';

export const bloomerangConfig = provider(Api.IntegrationProvider.Bloomerang, {
	displayName: 'Bloomerang',

	main: {
		writebacks: false,
	},

	keyFacts: {
		// Bloomerang has no prospect-vs-client distinction, so the ClientOnly/ProspectOnly choice is
		// meaningless here and the API default of All always applies.
		birthdayDisplay: false,
		customDateFields: true,
	},

	tags: {
		coreTags: true,
		customFields: true,
		providerTags: [
			providerTag('Status'),
			providerTag('Membership'),
			providerTag('EngagementScoreLabel', 'Engagement Score'),
			providerTag('PreferredCommunicationChannel', 'Preferred Communication Channel'),
			// Informational only — a restriction tag never suppresses email. That is what the toggles below do.
			providerTag('CommunicationRestrictions', 'Communication Restrictions'),
		],
		// Bloomerang records no single "do not email" flag, so each suppression signal is its own toggle.
		// Enabling one unsubscribes every matching constituent on the next sync, sourced ByIntegration, which
		// the Levitate UI cannot reverse — hence the warning in every subtitle.
		extraFields: [
			toggle('unsubscribeWhenOptedOut', {
				label: 'Unsubscribe Opted Out',
				subtitle: 'Cannot be undone from Levitate. Unsubscribes constituents whose email interest is Opted Out.',
			}),
			toggle('unsubscribeWhenPartialEmailInterests', {
				label: 'Unsubscribe Partial Email Interests',
				subtitle:
					'Cannot be undone from Levitate. These constituents opted into some email topics, which Levitate cannot honor selectively.',
			}),
			toggle('unsubscribeWhenDoNotSolicit', {
				label: 'Unsubscribe Do Not Solicit',
				subtitle:
					'Cannot be undone from Levitate. Do Not Solicit means "do not ask for money" and is not an email opt-out, so this suppresses people who may still want your newsletter.',
			}),
		],
	},
});
